import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'
import { isType } from '../utils/isType'


export const bannerPromoSelector = createSelector(
  pageSelectors.creative,
  (creative?: WpsRuntime.atv.wps.CreativesModelProps) =>
    creative && isBannerPromoModel(creative.atfTop) && creative.atfTop.image && {
        imagePath: creative.atfTop.image.path,
        imageLink: creative.atfTop.image.link,
        imageAlt: creative.atfTop.image.alt,
      } || undefined
)

export const heroQuickPromoSelector = createSelector(
  pageSelectors.creative,
  (creative?: WpsRuntime.atv.wps.CreativesModelProps) =>
    creative && isHeroQuickPromoModel(creative.atfBottom) && {
      title: creative.atfBottom.title,
      content: creative.atfBottom.content,
      image: creative.atfBottom.image,
    } || undefined
)

export const isBannerPromoModel = (
  component?: WpsRuntime.atv.wps.ComponentModelProps
): component is WpsRuntime.atv.wps.BannerPromoModel =>
  isType(component, 'atv.wps#BannerPromoModel')

export const isHeroQuickPromoModel = (
  component?: WpsRuntime.atv.wps.ComponentModelProps
): component is WpsRuntime.atv.wps.HeroQuickPromoModel =>
  isType(component, 'atv.wps#HeroQuickPromoModel')
